import { ChangeDetectionStrategy, Component, OnInit, computed, inject } from '@angular/core';
import { TableFilter, TableFilterResult } from '@shared/models/table-filter.model';
import * as fromOrders from '@root-store/orders-store/index';
import { Store } from '@ngrx/store';
import { OrdersTreeListUtilsService } from '@app/orders/services/orders-tree-utils.service';
import { DestroyableComponent } from '@core/components/destroyable/destroyable.component';
import { OrderItemRowTypeEnumRequestDto, OrderItemTypeEnumRequestDto } from '@core/services/apiclient';
@Component({
  selector: 'app-orders-list-filters',
  templateUrl: './orders-list-filters.component.html',
  styleUrls: ['./orders-list-filters.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrdersListFiltersComponent extends DestroyableComponent implements OnInit {
  private readonly store = inject<Store<fromOrders.State>>(Store);
  private readonly treeListUtils = inject(OrdersTreeListUtilsService);

  public filters: TableFilter[];
  public isTogglersExpanded = true;
  public isToggleDisplayed = true;
  readonly resultInfo = this.treeListUtils.resultInfo;
  readonly orderItemRowTypes = this.treeListUtils.itemRowTypes;
  readonly isSessionsDisplayed = computed(() =>
    this.orderItemRowTypes().some((type) => type === OrderItemRowTypeEnumRequestDto.EventSession),
  );
  readonly isProductsDisplayed = computed(() =>
    this.orderItemRowTypes().some((type) => type === OrderItemRowTypeEnumRequestDto.Product),
  );

  ngOnInit(): void {
    this.filters = this.treeListUtils.getOrdersFilters();
  }

  public setFilters(filters: TableFilterResult[]) {
    this.store.dispatch(fromOrders.actions.setOrdersListFilters({ filters }));
  }

  public toggleSessionType() {
    const types = [];
    if (!this.isSessionsDisplayed()) {
      types.push(OrderItemTypeEnumRequestDto.Session);
    }
    if (this.isProductsDisplayed() || !types?.length) {
      types.push(OrderItemTypeEnumRequestDto.Product);
    }
    this.setOrdersListType(types);
  }

  setOrdersListType(types: OrderItemTypeEnumRequestDto[]) {
    const ordersItemRowType = types
      .map((type) => {
        if (type === OrderItemTypeEnumRequestDto.Session) {
          return OrderItemRowTypeEnumRequestDto.EventSession;
        }
        if (type === OrderItemTypeEnumRequestDto.Product) {
          return OrderItemRowTypeEnumRequestDto.Product;
        }
        return null;
      })
      .filter((type): type is OrderItemRowTypeEnumRequestDto => type !== null);
    this.treeListUtils.setItemRowTypes(ordersItemRowType);
  }

  public toggleProductType() {
    const types = [];
    if (!this.isProductsDisplayed()) {
      types.push(OrderItemTypeEnumRequestDto.Product);
    }
    if (this.isSessionsDisplayed() || !types?.length) {
      types.push(OrderItemTypeEnumRequestDto.Session);
    }
    this.setOrdersListType(types);
  }

  showOrHideToggles() {
    this.isToggleDisplayed = !this.isToggleDisplayed;
    this.isTogglersExpanded = !this.isTogglersExpanded;
  }
}
